import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeProject(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/projects/${uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve());
}

export { removeProject };
